const API_PREFIX = process.env.REACT_APP_API_BASE_URL;

const ENDPOINTS = {
  ADMIN: {
    LOGIN: `${API_PREFIX}/admins/login`,
    REGENERATE_PASSWORD: `${API_PREFIX}/admins/request-password`,
    PROFILE: `${API_PREFIX}/admins/me`,
    API_LIMIT: `${API_PREFIX}/users/api-request-list`,
    UPDATE_API_LIMIT: `${API_PREFIX}/users/update-request-limit`,
    UPDATE_PASSWORD : `${API_PREFIX}/admins/update-password`,
    IMPERSONATE: `${API_PREFIX}/admins/impersonate`,
  },
  SUPPORT: {
    CONTACT: `${API_PREFIX}/support/contact`,
  },
  CHAT: {
    USERS: `${API_PREFIX}/chat-new/participants/list`,
    PARTICIPANT_BAN: `${API_PREFIX}/chat-new/participants/ban`,
    PARTICIPANT_UNBAN: `${API_PREFIX}/chat-new/participants/unban`,
    HISTORY: `${API_PREFIX}/chat-new/messages/history`,
    PIN_MESSAGE: `${API_PREFIX}/chat-new/messages/pin`,
    UNPIN_MESSAGE: `${API_PREFIX}/chat-new/messages/unpin`,
    UPDATE_MESSAGE: `${API_PREFIX}/chat-new/messages/edit`,
    DELETE_MESSAGE: `${API_PREFIX}/chat-new/messages/delete`,
    SCHEDULE_MESSAGE: `${API_PREFIX}/chat-new/messages/schedule`,
    SCHEDULE_MESSAGE_LIST: `${API_PREFIX}/chat-new/messages/schedule/list`,
    SCHEDULE_MESSAGE_UPDATE: `${API_PREFIX}/chat-new/messages/schedule/update`,
    SCHEDULE_MESSAGE_CANCEL: `${API_PREFIX}/chat-new/messages/schedule/cancel`,
    PARTICIPANT_BY_ID: `${API_PREFIX}/chat-new/participants/byid`,
  },
  CALENDER: {
    EVENTS: {
      LIST: `${API_PREFIX}/calendar/event/list`,
      SUBLIST: `${API_PREFIX}/calendar/event/subs/list`,
      SCHEDULE_EVENT_NOTIFICATION: `${API_PREFIX}/calendar/event/notification/schedule`
    }
  },
  EVENTS: {
    SEND_NOTIFICATION: `${API_PREFIX}/push/events`,
    SEND_STATION_NOTIFICATION: `${API_PREFIX}/push/stations`,
    SCHEDULED_NOTIFICATIONS: `${API_PREFIX}/calendar/event/notification/schedule/list`,
    REMOVE_SCHEDULED_NOTIFICATIONS: `${API_PREFIX}/calendar/event/notification/remove`
  },
  USERS: {
    UPDATE_PROFILE: `${API_PREFIX}/users/metadata`,
    UPDATE_STATION_INFO: `${API_PREFIX}/users/station-metadata`,
    LIST: `${API_PREFIX}/users/list`,
    TEAM: `${API_PREFIX}/users/list-member`,
    UPDATE_MEMBER: `${API_PREFIX}/users/update-member`,
    BAN: `${API_PREFIX}/users/ban`,
    REGISTER_MEMBER: `${API_PREFIX}/users/register-member`,
    PASSWORD_RESET: `${API_PREFIX}/users/request-password`,
    DELETE_MEMBER: (username) => `${API_PREFIX}/users/remove-member/${username}`,
    SEARCH : {
      CHAT_SERVICE : `${API_PREFIX}/chat-new/user/details`,
      POLLS_SERVICE : `${API_PREFIX}/polls/user/detail`,
      USER_SERVICE : `${API_PREFIX}/users/search`,
    }
  },
  FILES: {
    UPLOAD_BANNER: `${API_PREFIX}/files/upload`,
    DOWNLOAD: `${API_PREFIX}/files/download`,
  },
  BROADCAST: {
    MESSAGE: `${API_PREFIX}/calendar/message/broadcast/list`,
  },
  SCHEDULE: {
    EVENTS: `${API_PREFIX}/calendar/event/list`,
    EXPORT_EVENTS: `${API_PREFIX}/calendar/event/list/export`,
    TAGS: `${API_PREFIX}/calendar/event/tags/list`,
    CREATE_EVENT: `${API_PREFIX}/calendar/event/create`,
    UPDATE_EVENT: `${API_PREFIX}/calendar/event/update`,
    DELETE_EVENT: `${API_PREFIX}/calendar/event/delete`,
    REMOVE_EVENT: `${API_PREFIX}/calendar/event/remove`,
  },
  POLLS: {
    LIST: `${API_PREFIX}/polls/list`,
    ANSWERS: `${API_PREFIX}/polls/users/answers`,
    ANSWER_CREATE: `${API_PREFIX}/polls/answers/create`,
    ANSWER_DELETE: `${API_PREFIX}/polls/answers/delete`,
    ANSWER_UPDATE: `${API_PREFIX}/polls/answers/update`,
    USERS_LIST: `${API_PREFIX}/polls/users/list`,
    DELETE: `${API_PREFIX}/polls/delete`,
    START: `${API_PREFIX}/polls/start`,
    STOP: `${API_PREFIX}/polls/stop`,
    ARCHIVE: `${API_PREFIX}/polls/archive`,
    CREATE: `${API_PREFIX}/polls/create`,
    GET_BY_ID: `${API_PREFIX}/polls/get`,
    UPDATE: `${API_PREFIX}/polls/update`

  },
  CONTEST: {
    LIST: `${API_PREFIX}/polls/contest/list`,
    ANSWERS: `${API_PREFIX}/contest/users/answers`,
    USERS_LIST: `${API_PREFIX}/contest/users/list`,
    DELETE: `${API_PREFIX}/polls/contest/delete`,
    START: `${API_PREFIX}/polls/contest/start`,
    UPDATE: `${API_PREFIX}/polls/contest/update`,
    STOP: `${API_PREFIX}/polls/contest/stop`,
    END_CONTEST_GENERATE_WINNER: `${API_PREFIX}/polls/contest/end`,
    ARCHIVE: `${API_PREFIX}/polls/contest/archive`,
    CREATE: `${API_PREFIX}/polls/contest/create`,
    GET_BY_ID: `${API_PREFIX}/polls/contest/get`

  },
  BROADCAST: {
    MESSAGE: `${API_PREFIX}/calendar/message/broadcast/list`,
    REMOVE: `${API_PREFIX}/calendar/message/broadcast/remove`,
    MESSAGE_TO_LIVE: `${API_PREFIX}/calendar/message/broadcast`,

  },
  INVITES: {
    LIST: `${API_PREFIX}/users/invite`,
    TOGGLE_PODCAST: `${API_PREFIX}/users/podcast`,
    TOGGLE_AUDIO_ADS: `${API_PREFIX}/users/audioAds`,
    TOGGLE_ADS_WIZ: `${API_PREFIX}/users/adswizz-control`,
    TOGGLE_VIDEO_ADS: `${API_PREFIX}/users/videoAds`,
    TOGGLE_CLASSIC_ADS: `${API_PREFIX}/users/ads`,
    MODIFY_ALIAS_DATA: `${API_PREFIX}/users/approve-school`,
    TOGGLE_NOTIFICATIONS: `${API_PREFIX}/users/notifications`,
    UPDATE_METADATA: `${API_PREFIX}/users/metadata`,
    GET_METADATA: `${API_PREFIX}/users/metadata`,
    REGISTER_MEMBER: `${API_PREFIX}/users/register-member`,
    NEW_INVITE: `${API_PREFIX}/users/invite`,
    NEW_INVITE_WITHOUT_EMAIL: `${API_PREFIX}/users/invite-without-email`,
    REGISTER_STATION_ADMIN: `${API_PREFIX}/users/register-station-admin`,
    DELETE_INVITE_REQUEST: `${API_PREFIX}/users/invite`,
    RESEND_INVITE_REQUEST: `${API_PREFIX}/users/regenerate-token`,
    STATIONS_DATA:`${API_PREFIX}/users/stations-list`,
    UPDATE_STATION_GROUP_ADMIN:`${API_PREFIX}/users/station-group-access`,
  },
  APPS: {
    LIST: `${API_PREFIX}/stats/app-details`,
    CREATE: `${API_PREFIX}/stats/app-details`,
    UPDATE: (id) => `${API_PREFIX}/stats/app-details/${id}`,
    DELETE: (id) => `${API_PREFIX}/stats/app-details/${id}`,
  },
  SOCIAL: {
    UPDATE_TWITTER: `${API_PREFIX}/users/social/twitter`,
    TWITTER_OAUTH: `${API_PREFIX}/users/twitter`,
  },
  CLOUDFLARE: {
    PURGE_CACHE: `${API_PREFIX}/clear-cache`,
  },
};

export default ENDPOINTS;
